/* eslint-disable no-unused-expressions */
import React, { useMemo } from "react";
import styled from "styled-components";
import { useField } from "formik";
import {
  arrayOf,
  bool,
  func,
  number,
  oneOfType,
  shape,
  string
} from "prop-types";
import uuid from "uuid/v4";

import ToggleItem from "./components/ToggleItem";

const ToggleGroupWrapper = styled.div`
  display: flex;
`;

const ToggleGroup = props => {
  const { disabled, id, name, tabItems } = props;

  const fieldId = useMemo(() => id || uuid(), [id]);

  const toggleName = useMemo(
    () =>
      name ||
      tabItems
        .map(i => i.text.toLowerCase())
        .join("_")
        .replace(/\sgi/, "_"),
    [name]
  );
  const [field, , { setValue }] = useField(toggleName);

  const onChange = event => {
    const {
      target: { checked, value }
    } = event;
    if (checked) {
      setValue(value);
    }

    props.onChangeValue(event);
  };

  if (!tabItems.length) {
    return null;
  }

  const toggleItems = tabItems.map(item => (
    <ToggleItem
      key={item.value}
      checked={field.value === item.value}
      disabled={disabled}
      item={item}
      name={toggleName}
      onChange={onChange}
      role="radio"
      value={item.value}
    />
  ));

  return (
    <ToggleGroupWrapper id={fieldId} role="radiogroup">
      {toggleItems}
    </ToggleGroupWrapper>
  );
};

ToggleGroup.displayName = "ToggleGroup";
ToggleGroup.propTypes = {
  disabled: bool,

  id: string,
  name: string,
  onChangeValue: func,

  /* array of objects representing the tabs text and value */
  tabItems: arrayOf(
    shape({
      disabled: bool,
      subtext: string,
      text: string,
      value: oneOfType([bool, number, string])
    })
  ),

  /* the value of the tab that should be active by default */
  // eslint-disable-next-line react/no-unused-prop-types
  value: oneOfType([bool, number, string])
};

ToggleGroup.defaultProps = {
  disabled: false,
  id: null,
  name: null,
  onChangeValue: () => null,
  tabItems: [],
  value: null
};

export default ToggleGroup;
